import React, { Component } from 'react';
import Smear from './components/smash/smear';
import FingerTip from './components/smash/fingertip';
import { smesshySplash } from './smeshySplash';
import { Link, Navigate, createSearchParams } from 'react-router-dom';
import { STrace, SmesshyCommon, SmesshyCommonProps, SmesshyCommonState, SmesshyNavigateOptions } from './smesshyCommon';
import { SmesshyMainButton, SmesshySubButton } from './components/smesshyButton';
import GamePage from './components/gamePage';
import randoFacts from './randoFacts';
import PickRandomFact from './randoFacts';
import { ArtistProfile, ChallengeState, PaintingInfo, UnknownChallengeState } from './storageManager';
import CountDownText from './components/countDownText';
import { getTextSegments } from './components/smash/utils';
import ChallengeTile from './components/challengeTile';
import { RuleTester } from 'eslint';

export interface SmesshyState extends SmesshyCommonState {
    showSplash: boolean;
    splashText: string;
    inSetupApp: boolean;
    challengeState: ChallengeState;
    userName: string;
    selfPortraitUrl: string | undefined;

}
export interface SmesshyProps extends SmesshyCommonProps {
    ShowSplash: boolean;
}

export const Footer = (<div className='width-100p smesshy-main-panel h-items each-space-between h-padding-medium'>
                        <div className='text-small text-white'>
                            <a className='text-underline text-small text-white' href='/privPolApp'>Privacy</a> 
                        </div>
                        <div className='text-small text-white'>
                            &copy; 2025 <a className='text-underline text-small text-white' href='https://www.wrongsaw.com/'>Wrong Saw</a> 
                        </div>
                    </div>);

class Smesshy extends SmesshyCommon(Component<SmesshyProps, SmesshyState>) {

    splashSmearRef: React.RefObject<Smear> | null = null;

    constructor(props: SmesshyProps) {
        super(props);
        try {
            this.initCommon(props.AppObject);
            
            this.splashSmearRef = React.createRef();

            this.state = {
                showWaitSpin: false,
                splashText:  PickRandomFact(),
                authenticated: false,            
                showSplash: false,
                inSetupApp: false,
                doRefresh: false,
                userName: '',
                selfPortraitUrl: undefined,
                challengeState: {
                    challengeId: -1,
                    state: 'undefined',
                    prizePool: 0,
                    title: '',
                    voteRoundCurrent: 0,
                    voteRoundsTotal: 0,
                    timeLeft: 2*60,
                    roundTimeLeft: 2*60,
                    stampAllowed: false,
                    entries:0, 
                    rules:{stamps:false, timeLimit:0, styleGuide:'', colorRestrictions:[], startingWith:''}
                }
            };
        } catch (e: any) {
            props.AppObject.reportException(`smesshy, constructor`, 'ex', '', e)
        }
    }

    splashTimeout: NodeJS.Timeout | undefined = undefined;

    static async getSpecificChallengeStateAsync(controlFrom: any, cId: number | undefined, required: boolean) : Promise<ChallengeState> {
        controlFrom.pushWaitingFrame(controlFrom);
        STrace.addStep('smesshy', 'getChallengeStateAsync', '');
        let challengeState = await controlFrom.storageManager!.getChallengeStateAsync(cId, required);
        // challengeState = {
        //     challengeId: 138,
        //     state: 'paint',
        //     prizePool: 600,
        //     title: 'In Development',
        //     voteRoundCurrent: 0,
        //     voteRoundsTotal: 1,
        //     timeLeft: 1400,
        //     roundTimeLeft: 140000,
        //     stampAllowed: false,
        //     entries:123456, 
        //     rules:{stamps:false, 
        //         timeLimit:25, 
        //         styleGuide:'', 
        //         colorRestrictions:[], 
        //         //colorRestrictions:["#000000", "#FFFFFF", "#fdc70c", "#df0033"], be0c00 140841
        //         startingWith:'BAAAAAUFAwABBAAAAAUFBQUFBgUHBQgFCQUKBQsFDAUNBQ4FDwUQBREFEgUTBAAAAAUTAwADAQCIANMMBwCIANMAAwABAQDQAM0MBwDQAM0AAwACBP///wUFBQUFBgUHBQgFCQUKBQsFDAUNBQ4FDwUQBREE////BREDAAIBAIcA0gwHAIcA0gADAAIBANEAzgwHANIAzgADAAEEAAAABQUFBQQAAAAFBQMAAwEAhwDTBQcAhwDTAAMAAQEAzwDNBQcA0ADNAAMACgQUCEEFBQUFBQYFBwUIBQkFCgULBQwFDQQUCEEFDQMADAEAHQAbGgIAIQAbGgIAJwAbGgIALAAaGgIAMwAbGgIANwAcGgIAQwAhGgIASAAjGgIATgAjGgIAUwAgGgIAVwAdGgIAXwAfGgIAZgAhGgIAbQAhGgIAcgAhGgcAdgAeAAMABA=='
        //         }
        // };



        controlFrom.popWaitingFrame();
        return challengeState;
    }

    componentDidMount() {
        STrace.addStep('smesshy', 'didMound', '');

        // localStorage.setItem('_lastExceptionSource', '');
        // localStorage.setItem('_lastExceptionText', '');
        // localStorage.setItem('_lastExceptionKind', '');
        // localStorage.setItem('_lastExceptionCode', '');
        // console.log('last exception cleared');


        let controlThis = this;
        this.pushWaitingFrame(this);

        this.executeAsync(async ()=> {
            let challengeState = await Smesshy.getSpecificChallengeStateAsync(controlThis, undefined, false);
            if (challengeState !== undefined) {
                controlThis.setState({ challengeState:challengeState});
            }
        });
        if (!this._inPWA) {
            // no auth done, so trigger splash here
            if (this.props.ShowSplash === true) {
                this.setState({showSplash:true});
            }
        }
        this.popWaitingFrame();
    }

    async onPopulateAuthenticationState(authenticated: boolean) {
        STrace.addStep('smesshy', 'populateAuth', authenticated.toString());

        const controlThis = this;
        // we do this to ensure that a newly created account (in the auth backend) gets created on the app front end too
        if (authenticated && this._inPWA) {
            STrace.addStep('smesshy', 'getUserArtistProfileAsync', '');
            let prof = await controlThis.storageManager!.getUserArtistProfileAsync();
            if (prof !== undefined) {
                controlThis.setState({authenticated:true, userName: prof.artistName!, selfPortraitUrl: undefined});
                if (prof.artistImageId !== null && prof.artistImageId !== undefined) {
                    const fakeInfs: Array<PaintingInfo> = [{visibilityKind:'publ', paintingId: prof.artistImageId, artistProfile:{} as ArtistProfile}];
                    STrace.addStep('smesshy', 'getPaintingPreviews', 'selfPortrait');
                    const token =  (await controlThis.getAccessToken())!;
                    this.storageManager!.getPaintingPreviews(token, fakeInfs, (pins=>{
                        if (pins.length === 1) {
                            let selfPortraitUrl = pins[0].imageDetail!.preview;
                            this.setState({ selfPortraitUrl: selfPortraitUrl});
                        }
                    }))
                }
            } else {
                controlThis.setState({userName: '', selfPortraitUrl: undefined, authenticated: false});
            }

        } else {
            controlThis.setState({userName: '', selfPortraitUrl: undefined, authenticated: false});
        }
        // start the splash playback after any auth flow because it might cause a timeout on token refresh
        if (this.props.ShowSplash === true) {
            this.setState({showSplash:true});
        }
    }

    componentDidUpdate(prevProps: Readonly<SmesshyProps>, prevState: Readonly<SmesshyState>): void {

    }
    
    componentWillUnmount() {
        if (this.splashTimeout !== undefined) {
            clearTimeout(this.splashTimeout);
            this.splashTimeout = undefined;
        }
    }

    render() {
        try {
            return this.babyRender(); // what kind of nerd would name an important inner function with a pun taken from a netflix show?
        } catch (e: any) {
            this.props.AppObject.reportException(`smesshy, render`, 'ex', '', e)
            return <div>?!?!</div>;
        }
    }
    babyRender() {
        let controlThis = this;

        let voteInfo = <div> </div>;
        const timerExpire = ()=>{
            controlThis.setState({challengeState: UnknownChallengeState});

        };

        if (this.state.showSplash) {

            const showSplash = (splashSmash:Smear, actualRect: DOMRect | undefined)=> {
                if (actualRect != undefined) {
                    // drawn at 350x256 so center if needed
                    if (actualRect.width > 350 && actualRect.height > 256) {
                        splashSmash.setReplayOrigin((actualRect.width -350) / 2, (actualRect.height - 256) / 2);  
                    }
                }

                splashSmash.replayRecorded(3, 6, smesshySplash);

                controlThis.setState({showSplash:false})
                controlThis.splashTimeout = undefined;
                controlThis.props.AppObject.setState({showSplash: false});
            }

            this.splashTimeout = setTimeout(() => {
                let splashSmash = this.splashSmearRef!.current!
                if (splashSmash !== null) {
                    showSplash(splashSmash, splashSmash.boundingClientRect());
                } else {
                    // try again with a longer wait
                    this.splashTimeout = setTimeout(() => {
                        let splashSmash = this.splashSmearRef!.current!
                        if (splashSmash !== null) {
                            showSplash(splashSmash, splashSmash.boundingClientRect());
                        }
                    }, 2000);
                }}, 750);
        }

        let smesshyOptions = <></>;

        let challengeButtonInstallRequired = false;
        let challengeButtonTimeLeft= <div></div>;
        let challengeButtonText = '';
        let challengeButtonIcon = '';
        let challengeRulesText = '';
        let challengeTitleText = '';
        let challengeButtonNavigateTo : SmesshyNavigateOptions | string = '';

        if (this.state.challengeState.title !== undefined && this.state.challengeState.title.length > 0) {
            challengeTitleText = `"${this.state.challengeState.title}"`
        }
        challengeRulesText = `Special Rules: No 'stamps' allowed`;
        if (this.state.challengeState.stampAllowed) {
            challengeRulesText = 'Special Rules: Collage challenge, stamp it up!';
        }

        let showChallengePane = false;
        switch (this.state.challengeState.state) {
            case 'undefined':
                challengeButtonTimeLeft= <div></div>;
                challengeButtonText = 'Wait';
                challengeButtonIcon = 'wait.png';
                challengeTitleText = '(Still looking it up...)';
                challengeRulesText = `'Ya gotta hang on`;
                challengeButtonNavigateTo = 'refresh';
                break;
            case 'unknown':
                challengeButtonTimeLeft= <div></div>;
                challengeButtonText = 'Fix it';
                challengeButtonIcon = 'confused.png';
                challengeTitleText = 'Smesshy is Confused';
                challengeRulesText = `Push 'Fix it' to fix it`;
                challengeButtonNavigateTo = 'refresh';
                break;
            case 'none':
                challengeButtonTimeLeft= <CountDownText SecondsInitial={this.state.challengeState.timeLeft} OnFinish={()=>{timerExpire()}}/>;
                challengeButtonText = 'Wait';
                challengeButtonIcon = 'wait.png';
                challengeTitleText = 'Finished, new one soon';
                challengeRulesText = `You should look at the Winners`;
                challengeButtonNavigateTo = 'refresh';
                break;
            case 'paint':
                showChallengePane = true;
                challengeButtonTimeLeft= <CountDownText SecondsInitial={this.state.challengeState.timeLeft} OnFinish={()=>{timerExpire()}}/>;
                challengeButtonText = 'Enter Now';
                challengeButtonIcon = 'enter.png';
                challengeButtonNavigateTo = {To: {pathname:'/painting', search:`?${createSearchParams({saveMode: 'chal', stampAllowed: this.state.challengeState.stampAllowed.toString()})}`}};
                challengeButtonInstallRequired = true;
                break;
            case 'vote':
                showChallengePane = true;
                challengeButtonTimeLeft= <CountDownText SecondsInitial={this.state.challengeState.roundTimeLeft} OnFinish={()=>{timerExpire()}}/>;
                challengeButtonText = 'Vote Now';
                challengeButtonIcon = 'vote.png';
                challengeButtonNavigateTo = {To: '/vote'};
                challengeButtonInstallRequired = true;
                break;
            case 'working':
                showChallengePane = true;
                challengeButtonTimeLeft= <CountDownText SecondsInitial={this.state.challengeState.timeLeft} OnFinish={()=>{timerExpire()}}/>;
                challengeButtonText = 'Counting';
                challengeButtonIcon = 'wait.png';
                challengeButtonNavigateTo = 'refresh';
                break;
            default:
                break;
        }

        let challengeButton = <SmesshyMainButton AppObject={this._app!}
        Display={
            <div className='h-items h-medium-gap width-content'>
                <div className='v-items v-small-gap width-content'>
                    <div>{challengeButtonText}</div>
                    <div>{challengeButtonTimeLeft}</div>
                </div>
                <img src={challengeButtonIcon} style={{height:this._app!.GetScaledPxHeightVh(46)}}/>
            </div> }
        
        Haptic={this.doButtonHaptic()}
        StartPushedState={false}
        OnPressFinish={async (): Promise<boolean>=>{
            if (challengeButtonNavigateTo === 'refresh') {
                controlThis.setState({doRefresh:true});
            } else {
                if (challengeButtonInstallRequired) {
                    let reqNav = controlThis.requireSetup(() => {
                        controlThis.setState({navigateTo: challengeButtonNavigateTo as SmesshyNavigateOptions});
                    });
                    if (reqNav != undefined) {
                        controlThis.setState({navigateTo: reqNav});
                    }
                }
            } 
            return true;
        }}
    />;

        let challengeResultButton = <SmesshyMainButton AppObject={this._app!}
            Display={
                <>
                    <div className='text-large'>
                        Winners
                    </div>
                    <img src='winners.png' style={{height:this._app!.GetScaledPxHeightVh(46)}}/>
                </>                                                    
            }
            Haptic={this.doButtonHaptic()}
            StartPushedState={false}
            OnPressFinish={async (): Promise<boolean>=>{
                if (controlThis.state.challengeState.state === 'unknown') {
                    controlThis.setState({doRefresh:true});
                } else if (controlThis.state.challengeState.state === 'paint') {
                    controlThis.setState({navigateTo: {To: '/result'}});
                } else {
                    controlThis.setState({navigateTo: {To: '/result'}});
                }
                return true;
            }}
        />;
        let challengeBestEverButton = <SmesshyMainButton AppObject={this._app!}
            Display={ <div style={{height: this._app!.GetScaledPxHeightVh(92)}}>
            <svg viewBox="0 0 184 308" xmlns="http://www.w3.org/2000/svg" style={{height:'100%', width: '100%'}}>
                <rect width="180" height="300" style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '4px', strokeLinejoin: 'round', paintOrder: 'fill', fill: 'rgb(212, 199, 180)'}} x="2" y="2"></rect>
                <path style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '4px'}} d="M 0 110L 180 110"></path>
                <path style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '6px'}} d="M 8 304 L 174 304"></path>
                <rect x="166" y="58" width="8" height="40" rx="4" ry="4" style={{stroke: 'rgb(0, 0, 0)', fill: 'rgb(229, 229, 229)', paintOrder: 'fill', strokeWidth: '2px'}} transform=""></rect>
                <rect x="166" y="122.214" width="8" height="60" rx="8" ry="4" style={{stroke: 'rgb(0, 0, 0)', fill: 'rgb(229, 229, 229)', paintOrder: 'fill', strokeWidth: '2px'}}></rect>
                <g transform="matrix(0.990268, -0.139173, 0.139173, 0.990268, -0.305253, 9.462836)" style={{transformOrigin: '82.346px 21.8583px'}}>
                    <text style={{fill: 'rgb(131, 131, 3)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="22" y="48">B</text>
                    <text style={{fill: 'rgb(255, 254, 6)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="24" y="46">B</text>
                </g>
                <g transform="matrix(1, 0, 0, 1, 13.736372, 8.241823)">
                    <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="47" y="48">E</text>
                    <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="49" y="46">E</text>
                </g>
                <g transform="matrix(1, 0, 0, 1, 37.250278, 18.842093)">
                    <text style={{fill: 'rgb(122, 45, 1)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="65" y="34">S</text>
                    <text style={{fill: 'rgb(254, 94, 2)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="67" y="32">S</text>
                </g>
                <g style={{transformOrigin: '143.547px 21.8583px'}} transform="matrix(0.994522, 0.104528, -0.104528, 0.994522, 5.494549, 32.662041)">
                    <text style={{fill: 'rgb(2, 82, 26)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}}  x="131" y="34">T</text>
                    <text style={{fill: 'rgb(4, 158, 49)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="133" y="32">T</text>
                </g>
                <g transform="matrix(1, 0, 0, 1, 13.736372, 8.241823)">
                    <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="16" y="160">E</text>
                    <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="17" y="158">E</text>
                </g>
                <g transform="matrix(0.990268, -0.139173, 0.139173, 0.990268, -0.305253, 9.462836)" style={{transformOrigin: '82.346px 21.8583px'}}>
                    <text style={{fill: 'rgb(131, 131, 3)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="46" y="170">V</text>
                    <text style={{fill: 'rgb(255, 254, 6)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="48" y="168">V</text>
                </g>
                <g transform="matrix(1, 0, 0, 1, 13.736372, 8.241823)">
                    <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="78" y="190">E</text>
                    <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="80" y="188">E</text>
                </g>
                <g transform="matrix(1, 0, 0, 1, 13.736372, 11.599603)">
                    <text style={{fill: 'rgb(131, 49, 1)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="110" y="210">R</text>
                    <text style={{fill: 'rgb(254, 94, 2)', fontFamily: 'Tahoma', fontSize: '48px', fontWeight: '700', whiteSpace: 'pre'}} x="112" y="208">R</text>
                </g>
            </svg>
            </div> }
            Haptic={this.doButtonHaptic()}
            StartPushedState={false}
            OnPressFinish={async (): Promise<boolean>=>{
                STrace.addStep('gallery doors', 'pick door', 'global popular');
                controlThis.setState({navigateTo:{To:{pathname:'/gallery-doors/gallery', search:`?${createSearchParams({title: 'All time best from challenges:', scope: 'global', filter:'popular', auth:'false'})}`} }})
                return true;
            }}
        />;
        

        let challengeInfo = <div className='v-items smesshy-ask-inset text-small'>
            <div className='text-large smesshy-heading-outset' style={{color: 'rgb(253, 199, 12)'}}> 
                <div className='h-items each-cross-center each-space-between'> 
                    <div>Challenges</div>
                    <div className='h-items h-medium-gap each-cross-center'> 
                        <div>Prize Pool:</div>
                        <div className='text-medium'>{`$${this.state.challengeState.prizePool}`}</div>
                    </div>
                </div>
            </div>

            <div className='h-items h-medium-gap each-space-between'> 
                <div className='v-items v-medium-gap self-remaining'> 
                    {showChallengePane ?
                    <div className='top-margin-large'>
                        <ChallengeTile 
                            AppObject={this._app!} 
                            AppShape={this._appShape}
                            Title={this.state.challengeState.title}
                            Id={this.state.challengeState.challengeId}
                            OnChallengeStateNeeded={async (cId:number)=>{
                                if (this.state.challengeState.challengeId === cId) {
                                    return this.state.challengeState;
                                } else {
                                    return await Smesshy.getSpecificChallengeStateAsync(controlThis, cId, true);
                                }
                            }}
                            Options={{ShowResults: false, ShowTitle: true, ShowRules: true, ShowPrize: false, ShowEntrants:true, Prefix:'On Now:'}}
                        />
                    </div> :
                    <>
                        <div className='h-items h-medium-gap each-cross-center'> 
                            <div>On Now:</div>
                            <div className='text-medium text-bold'>{challengeTitleText}</div>
                        </div>
                        <div className='h-items h-medium-gap each-cross-center'> 
                            <div>{challengeRulesText}</div>
                        </div>
                    </>}

                    <div className='h-items h-large-gap'> 
                        {challengeButton}
                        {challengeResultButton}
                    </div>
                </div>
                <div className='top-margin-large'>
                    {challengeBestEverButton}
                </div>
            </div>
        </div>


        // lunchbox stuff
        let namePart1 = '';
        let namePart2 ='';
        let namePart3 ='';
        let namePart4 ='';
        if (this.state.userName.length > 0) {
            let segments = getTextSegments(this.state.userName, '32px Rubik Distressed', 190);
            if (segments.length > 0) {
            namePart1 = segments[0];
            }
            if (segments.length > 1) {
                namePart2 = segments[1];
            }
            if (segments.length > 2) {
                namePart3 = segments[2];
            }
            if (segments.length > 3) {
                namePart4 = segments[3];
            }
        }

        let artistImage = <></>;
        if (this.state.selfPortraitUrl !== undefined) {
            artistImage = <image href={this.state.selfPortraitUrl} x='0' y={-56} width={224} height={448} />
        }

        let lunchboxButton = <SmesshyMainButton AppObject={this._app!}
            ExtraStyleClass='width-100p height-100p'
            Display={
                <svg viewBox='0 0 256 256' className='width-100p height-100p' xmlns='http://www.w3.org/2000/svg'>
                    <defs>

                        <linearGradient gradientUnits='userSpaceOnUse' x1='127.5' y1='62' x2='127.5' y2='247' id='gradient-out' gradientTransform='matrix(0.607497, 0.794322, -1.232432, 0.92973, 238.954942, -90.919285)'>
                        <stop offset='0' stopColor='rgb(255, 121, 121)'></stop>
                        <stop offset='1' stopColor='rgb(190, 0, 0)'></stop>
                        </linearGradient>
                        <linearGradient gradientUnits='userSpaceOnUse' x1='127.5' y1='62' x2='127.5' y2='247' id='gradient-in' gradientTransform='matrix(0.542497, 0.682687, -1.100567, 0.799065, 228.029755, -56.427884)'>
                        <stop offset='0' stopColor='rgb(190, 0, 0)'></stop>
                        <stop offset='1' stopColor='rgb(255, 121, 121)'></stop>
                        </linearGradient>
                    </defs>
                    <rect x='18' y='67' width={219} height='175' fill='rgb(188, 188, 188)' strokeWidth='14px' strokeLinejoin='round' rx='19.918' ry='19.918'></rect>
                    <svg x='16' y='72' width='224' height='168' viewBox='0 0 224 168' xmlns='http://www.w3.org/2000/svg' transform='matrix(1, 0, 0, 1, 16, 72)'>
                        {artistImage}
                    </svg>

                    <rect x='11' y='67' width='233' height='175' fill='none' stroke='rgb(255, 0, 0)' strokeWidth='14px' strokeLinejoin='round' rx='19.918' ry='19.918'></rect>
                    <rect x='6' y='62' width='243' height='185' strokeLinejoin='round' fill='none' strokeWidth='4px' paintOrder='fill' stroke='url(#gradient-out)' rx='19.918' ry='19.918'></rect>
                    <rect x='20' y='75' width='217' height='159' strokeLinejoin='round' fill='none' strokeWidth='4px' paintOrder='fill' stroke='url(#gradient-in)' rx='12.313' ry='12.313'></rect>
                    <rect x='110' y='52' width='32' height='8' fill='rgb(188, 188, 188)' strokeLinejoin='round' rx='2.173' ry='2.173'></rect>
                    <rect x='32' y='54' width='16' height='6' fill='rgb(188, 188, 188)' strokeLinejoin='round' rx='2.173' ry='2.173'></rect>
                    <rect x='205' y='54' width='16' height='6' fill='rgb(188, 188, 188)' strokeLinejoin='round' rx='2.173' ry='2.173'></rect>
                    <path d='M 89.713 45.155 C 84.488 45.155 80.043 43.486 78.396 41.155 L 54.713 41.155 C 51.399 41.155 48.713 38.469 48.713 35.155 C 48.713 31.841 51.399 29.155 54.713 29.155 L 206.713 29.155 C 210.027 29.155 212.713 31.841 212.713 35.155 C 212.713 38.469 210.027 41.155 206.713 41.155 L 183.03 41.155 C 181.383 43.486 176.938 45.155 171.713 45.155 C 167.373 45.155 163.57 44.003 161.463 42.277 C 159.356 44.003 155.553 45.155 151.213 45.155 C 146.873 45.155 143.07 44.003 140.963 42.277 C 138.856 44.003 135.053 45.155 130.713 45.155 C 126.373 45.155 122.57 44.003 120.463 42.277 C 118.356 44.003 114.553 45.155 110.213 45.155 C 105.873 45.155 102.07 44.003 99.963 42.277 C 97.856 44.003 94.053 45.155 89.713 45.155 Z M 53.713 35.155 C 53.713 36.812 55.497 38.155 57.697 38.155 L 73.729 38.155 C 75.929 38.155 77.713 36.812 77.713 35.155 C 77.713 33.498 75.929 32.155 73.729 32.155 L 57.697 32.155 C 55.497 32.155 53.713 33.498 53.713 35.155 Z M 184.713 35.155 C 184.713 36.812 186.497 38.155 188.697 38.155 L 204.729 38.155 C 206.929 38.155 208.713 36.812 208.713 35.155 C 208.713 33.498 206.929 32.155 204.729 32.155 L 188.697 32.155 C 186.497 32.155 184.713 33.498 184.713 35.155 Z' fill='rgb(255, 54, 54)' transform='matrix(0.992546, -0.121869, 0.121869, 1.4, 0, 0)'></path>
                    <line fill='rgb(216, 216, 216)' strokeWidth='4px' stroke='rgb(121, 121, 121)' strokeLinecap='round' x1='40' y1='56' x2='72' y2='44'></line>
                    <line fill='rgb(216, 216, 216)' strokeWidth='4px' stroke='rgb(121, 121, 121)' strokeLinecap='round' x1='204' y1='24' x2='212' y2='56'></line>
                    <path fill='rgba(216, 216, 216, 0.424)' d='M 21.546 97.295 C 21.83 98.148 23.875 105.819 23.461 106.232 C 22.906 106.788 21.409 111.203 22.504 112.297 C 23.908 113.702 26.569 116.936 25.057 119.958 C 23.906 122.261 22.442 123.593 21.227 126.023 C 20.51 127.457 21.781 129.279 22.185 130.492 C 23.169 133.445 20.844 135.981 19.631 137.195 C 17.955 138.87 23.143 141.982 21.546 143.579 C 18.383 146.742 18.711 153.755 15.481 156.985 C 13.185 159.282 10.496 158.657 8.778 162.093 C 7.776 164.097 12.301 170.723 13.566 171.988 C 14.164 172.585 15.598 172.221 16.12 173.265 C 17.581 176.186 17.785 179.752 19.631 182.521 C 20.231 183.421 18.156 183.039 18.035 183.16 C 17.836 183.359 17.437 186.073 17.716 186.352 C 22.868 191.504 17.099 195.378 18.673 201.674 C 20.196 207.762 23.077 209.204 25.377 213.803 C 26.335 215.719 24.419 215.787 24.419 217.953 C 24.419 223.002 22.675 228.657 26.015 231.998 C 27.146 233.129 26.429 236.242 27.611 237.424 C 28.605 238.418 29.18 236.759 29.845 237.424 C 30.789 238.368 35.208 248.022 39.421 243.808 C 40.284 242.945 42.433 234.052 44.529 236.147 C 45.969 237.588 49.49 235.682 50.594 236.786 C 54.057 240.25 61.345 244.312 68.469 242.531 C 70.595 242 70.675 239.666 73.257 239.02 C 78.514 237.706 83.05 241.52 87.94 240.297 C 91.461 239.417 90.141 236.265 92.409 235.509 C 94.416 234.84 97.558 236.446 99.431 235.509 C 101.392 234.529 104.05 232.082 106.135 231.04 C 108.758 229.728 117.277 235.18 120.18 236.147 C 122.985 237.083 127.288 236.07 130.394 237.105 C 132.754 237.892 133.965 239.848 136.14 240.935 C 139.505 242.618 142.942 241.394 146.354 242.531 C 148.381 243.207 152.687 244.951 154.973 243.808 C 158.957 241.816 160.255 236.06 163.91 234.232 C 166.97 232.702 174.611 234.394 177.955 235.509 C 179.334 235.969 182.108 234.229 182.743 233.594 C 183.262 233.075 188.935 234.143 190.085 233.913 C 194.263 233.077 194.985 229.708 198.065 228.167 C 200.994 226.703 203.884 225.098 206.683 223.699 C 208.002 223.039 211.225 228.192 213.067 228.806 C 214.879 229.41 218.334 230.003 220.09 229.125 C 222.592 227.874 224.037 224.801 227.431 225.933 C 229.689 226.686 233.391 231.093 236.05 229.763 C 237.425 229.076 237.995 226.193 238.603 224.975 C 240.31 221.561 242.455 215.059 244.988 212.526 C 246.316 211.198 244.026 205.489 243.711 204.227 C 242.134 197.92 236.264 188.901 238.603 181.883 C 239.618 178.838 241.693 174.233 240.519 170.711 C 240.032 169.252 238.253 167.745 237.646 165.923 C 234.957 157.856 238.521 147.563 234.773 140.068 C 232.691 135.903 236.248 131.951 237.646 129.853 C 238.735 128.22 238.284 125.356 238.284 123.469 C 238.284 111.872 233.444 100.08 227.751 90.591 C 226.235 88.065 225.906 83.321 223.92 81.334 C 222.936 80.35 220.201 82.188 219.132 81.654 C 216.682 80.428 214.831 78.373 211.79 77.504 C 204.972 75.556 199.444 78.546 192.638 77.185 C 187.214 76.1 181.972 75.316 176.678 73.993 C 173.6 73.223 170.144 75.645 167.102 74.631 C 161.858 72.883 156.72 69.448 150.823 72.397 C 144.688 75.464 134.384 82.898 126.564 81.334 C 122.39 80.5 118.374 76.018 116.349 73.993 C 114.518 72.162 107.562 74.894 104.858 73.993 C 97.62 71.58 81.514 66.513 73.576 70.482 C 69.161 72.689 60.344 75.444 57.297 79.1 C 54.138 82.891 53.691 93.192 49.955 95.06 C 48.983 95.546 47.449 93.715 46.444 93.464 C 41.832 92.311 39.09 88.034 34.314 86.442 C 31.468 85.493 25.478 89.902 22.823 91.23 C 21.428 91.927 19.281 91.26 18.035 92.507' transform='matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)'/>
                    <path fill='rgb(149, 111, 93)' d='M 43.571 83.888 C 43.571 87.125 44.108 89.865 44.848 92.826 C 45.255 94.452 44.106 97.087 44.848 98.571 C 46.768 102.411 48.466 104.423 46.125 109.105 C 45.878 109.598 47.987 118.335 48.04 118.362 C 49.847 119.265 55.058 114.842 54.105 112.935 C 52.637 110 54.035 106.271 53.147 102.721 C 52.562 100.382 50.7 97.721 49.955 94.741 C 49.193 91.69 50.307 88.292 51.232 86.442 C 51.607 85.692 48.219 79.279 47.401 78.462 C 46.729 77.789 46.444 80.512 46.444 81.015 C 46.444 82.8 45.857 85.484 43.89 85.484' transform='matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)'/>
                    <path fill='rgb(149, 111, 93)' d='M 145.716 113.574 C 146.965 114.198 155.147 116.013 155.292 116.447 C 155.742 117.798 153.741 120.642 154.653 121.554 C 155.98 122.88 163.651 121.355 162.314 118.681 C 161.703 117.459 159.992 116.909 159.441 115.808 C 158.886 114.697 160.502 113.358 159.441 112.297 C 157.529 110.385 155.147 112.646 153.696 109.743 C 153.222 108.797 153.377 100.167 153.377 100.167 C 153.377 100.167 151.964 103.949 151.781 104.317 C 150.076 107.727 149.643 112.2 146.993 114.851' transform='matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)'/>
                    <path fill='rgb(119, 93, 93)' d='M 86.344 226.891 C 89.002 230.877 80.509 236.645 78.683 240.297 C 78.454 240.755 76.754 244.113 77.087 244.447 C 80.509 247.869 82.34 238.555 83.152 237.743 C 84.219 236.676 87.854 234.405 88.579 232.955 C 89.002 232.108 88.276 230.67 88.579 229.763 C 88.826 229.02 90.686 227.083 89.855 226.252 C 89.011 225.408 87.925 228.487 86.983 228.487' transform='matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)'/>
                    <text fill='rgb(200, 0, 0)' fontFamily='Rubik Distressed' fontSize='32px' x='28' y='120'>{namePart1}</text>
                    <text fill='rgb(200, 0, 0)' fontFamily='Rubik Distressed' fontSize='32px' x='28' y='154'>{namePart2}</text>
                    <text fill='rgb(200, 0, 0)' fontFamily='Rubik Distressed' fontSize='32px' x='28' y='188'>{namePart3}</text>
                    <text fill='rgb(200, 0, 0)' fontFamily='Rubik Distressed' fontSize='32px' x='28' y='222'>{namePart4}</text>
                </svg>
            }
            Haptic={this.doButtonHaptic()}
            StartPushedState={false}
            OnPressFinish={async (): Promise<boolean>=>{
                controlThis.setState({navigateTo:{To:{pathname:'/lunchbox'} }});
                return true;
            }}
        />;

        let galleryButton = <SmesshyMainButton AppObject={this._app!}
                ExtraStyleClass='width-100p height-100p'
                Display={
                    <svg viewBox="0 0 204 308" className='width-100p height-100p' xmlns="http://www.w3.org/2000/svg" >
                        <defs>
                            <linearGradient gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="200" y2="0" id="gradient-0" gradientTransform="">
                            <stop offset="0" style={{stopColor: 'rgb(160, 160, 170)'}}></stop>
                            <stop offset="0.5" style={{stopColor: 'rgb(220, 220, 230)'}}></stop>
                            <stop offset="1" style={{stopColor: 'rgb(180, 180, 190)'}}></stop>
                            </linearGradient>
                        </defs>
                        <rect width="200" height="300" style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '4px', strokeLinejoin: 'round', paintOrder: 'fill', fill: 'url(#gradient-0)'}} x="2" y="2"></rect>
                        <rect width="200" height="90" style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '4px', strokeLinejoin: 'round', paintOrder: 'fill', fill: 'url(#gradient-0)'}} y="2" x="2"></rect>
                        <path style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '6px', strokeLinecap: 'round'}} d="M 15 20 L 15 75"></path>
                        <path style={{stroke: 'rgb(0, 0, 0)', strokeWidth: '6px', strokeLinecap: 'round'}} d="M 15 115 L 15 205"></path>
                        <ellipse style={{stroke: 'rgb(0, 0, 0)'}} cx="20" cy="304" rx="3" ry="3"></ellipse>
                        <ellipse style={{stroke: 'rgb(0, 0, 0)'}} cx="180" cy="304" rx="3" ry="3"></ellipse>
                        <g style={{transformOrigin: '143.547px 21.8583px'}} transform="matrix(0.994522, 0.104528, -0.104528, 0.994522, -109.991791, 111.175941)">
                            <text style={{fill: 'rgb(2, 82, 26)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} y="34" x="134">F</text>
                            <text style={{fill: 'rgb(4, 158, 49)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="136" y="32">F</text>
                        </g>
                        <g transform="matrix(1, 0, 0, 1, 5.085655, 112.202271)">
                            <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="45.736" y="45.6">E</text>
                            <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="47.736" y="43.6">E</text>
                        </g>
                        <g transform="matrix(1, 0, 0, 1, 27.086218, 121.079796)">
                            <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="54" y="34">E</text>
                            <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="56" y="32">E</text>
                        </g>
                        <g transform="matrix(1, 0, 0, 1, -3.860551, 138.33493)">
                            <text style={{fill: 'rgb(122, 45, 1)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="110" y="34">D</text>
                            <text style={{fill: 'rgb(251, 4, 43)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="112" y="32">D</text>
                        </g>
                        <g transform="matrix(1, 0, 0, 1, 66.001686, 151.543335)">
                            <text style={{fill: 'rgb(122, 45, 1)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="0" y="74">M</text>
                            <text style={{fill: 'rgb(254, 94, 2)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="2" y="72">M</text>
                        </g>
                        <g transform="matrix(0.990268, -0.139173, 0.139173, 0.990268, 59.109715, 143.977844)" style={{transformOrigin: '82.346px 21.8583px'}}>
                            <text style={{fill: 'rgb(2, 69, 128)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="42" y="80">E</text>
                            <text style={{fill: 'rgb(4, 135, 253)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="44" y="78">E</text>
                        </g>
                        <g transform="matrix(0.990268, -0.139173, 0.139173, 0.990268, 59.109715, 143.977844)" style={{transformOrigin: '82.346px 21.8583px'}}>
                            <text style={{fill: 'rgb(131, 131, 3)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="82" y="84">!</text>
                            <text style={{fill: 'rgb(255, 254, 6)', fontFamily: 'Tahoma', fontSize: '40px', fontWeight: 700, whiteSpace: 'pre'}} x="84" y="82">!</text>
                        </g>

                        <image href='flowers.png' width="50" height="100" x="86.114" y="9.756" transform="matrix(0.258819, -0.965926, 0.965926, 0.258819, 26.063978, -15.892667)" style={{transformBox: 'fill-box', transformOrigin: '50% 50%'}}> </image>
                    </svg>}
                Haptic={this.doButtonHaptic()}
                StartPushedState={false}
                OnPressFinish={async (): Promise<boolean>=>{
                    controlThis.setState({navigateTo: {To: '/feed'}});
                    return true;
                }}
            />;


        let paintButton = <SmesshyMainButton AppObject={this._app!}
            Display={
                <div className='smesshy-paint-button width-100p height-100p'>
                </div>}
                Haptic={this.doButtonHaptic()}
                StartPushedState={false}
                ExtraStyleClass='width-100p'
                OnPressFinish={async (): Promise<boolean>=>{
                    if (controlThis._inPWA) {
                        controlThis.setState({navigateTo: {To:{pathname:'/painting', search:`?${createSearchParams({saveMode: 'any'})}`}}});
                    } else {
                        controlThis.setState({navigateTo: {To:{pathname:'/painting', search:`?${createSearchParams({mode: 'anon'})}`}}});
                    }
                    return true;
                }}
            />;

        smesshyOptions= <>
            {challengeInfo}
            <div className='v-items smesshy-ask-inset text-small'>
                <div className='text-large smesshy-heading-outset' style={{color: 'rgb(253, 199, 12)'}}> 
                    <div className='h-items each-cross-center each-space-between'> 
                        <div>Social Dumpster Fire</div>
                    </div>
                </div>
                <div className='v-items'>

                    <div className='h-items h-medium-gap each-space-between top-margin-large'> 
                        <div className='h-items width-100p h-large-gap' 
                            style={{height:this._app!.GetScaledPxHeightVh(135)}}>
                                {galleryButton}
                                {lunchboxButton}
                                <div style={{width:this._app!.GetScaledPxWidthVw(61)}}>
                                <SmesshyMainButton AppObject={this._app!}
                                    ExtraStyleClass='height-100p width-100p'
                                    Display={
                                        <div className='v-items'>
                                            <img src='following.png' className='self-cross-center' style={{width:this._app!.GetScaledPxWidthVw(32)}}/>

                                            <div className='h-items h-large-gap'>
                                                <div className='text-large text-vertical-bt'>
                                                    Followers
                                                </div>
                                                <div className='text-large text-large text-vertical-tb'>
                                                    Following
                                                </div>
                                            </div>
                                            <img src='followers.png' className='self-cross-center' style={{width:this._app!.GetScaledPxWidthVw(32)}}/>

                                        </div>
                                    }
                                    Haptic={this.doButtonHaptic()}
                                    StartPushedState={false}
                                    OnPressFinish={async (): Promise<boolean>=>{
                                        STrace.addStep('main', 'following', '');
                                        controlThis.setState({navigateTo:{To:'/following'}});
                                        return true;
                                    }}
                                />
                                </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='v-items smesshy-ask-inset text-small'>
                <div className='text-large smesshy-heading-outset' style={{color: 'rgb(253, 199, 12)'}}> 
                    <div className='h-items each-cross-center each-space-between'> 
                        <div>Just Me</div>
                    </div>
                </div>
                <div className='h-items h-medium-gap each-space-between top-margin-large'> 
                    <SmesshyMainButton AppObject={this._app!}
                        ExtraStyleClass='width-100p height-100p'
                        Display={
                            <span className='text-large'>Stats</span>
                        }
                        Haptic={this.doButtonHaptic()}
                        StartPushedState={false}
                        OnPressFinish={async (): Promise<boolean>=>{
                            controlThis.setState({navigateTo: {To: '/stats'}});
                            return true;
                        }}
                    />
                    <div className='h-items width-100p h-large-gap' 
                        style={{height:this._app!.GetScaledPxHeightVh(36)}}>
                        {paintButton}
                    </div>

                    <SmesshyMainButton AppObject={this._app!}
                        ExtraStyleClass='width-100p height-100p'
                        Display={
                            <>
                                <div className='text-large'>
                                    Settings
                                </div>
                                <img src='settings.png' style={{height:this._app!.GetScaledPxHeightVh(32)}}/>
                            </>                                                    
                        }
                        Haptic={this.doButtonHaptic()}
                        StartPushedState={false}
                        OnPressFinish={async (): Promise<boolean>=>{
                            controlThis.setState({navigateTo: {To:'/settings'}});
                            return true;
                        }}
                    />

                </div>
            </div>
        </>;
        
        return this.renderFramework(
            <GamePage
                AppObject={this._app!}
                AppShape={this._appShape}
                ShowFooter={true}
                ShowHeader={true}
                ShowRefresh={false}
                RequireAuth={this._inPWA}
                Title = {<div className='width-100p smesshy-main-panel h-items each-space-around'>
                            <div className='text-large text-bold text-white'>
                                Smesshy!
                            </div>
                        </div>}
                OnPopulateAuthenticationState={this._inPWA ? async (authenticated: boolean) => { await controlThis.onPopulateAuthenticationState(authenticated) } : undefined}
                Body={
                    <>
                        <div className='width-100p smesshy-main h-items group-center h-padding-medium  v-padding-medium' >
                            <div className='self-cross-center' style={{width: this._app!.GetScaledPxWidthVw(350), height: this._app!.GetScaledPxHeightVh(256), position:'relative'}}>
                                <Smear
                                    ref={this.splashSmearRef}
                                    contextKey='smesshySplash'
                                    AppObject={this.props.AppObject}
                                    CanCacheCtx={true}
                                    Disabled={false}
                                    AvgHeavyRadius={FingerTip.standardFingerRadius}
                                    AvgLightRadius={FingerTip.standardFingerRadius}
                                    UseMouse={true}
                                    Color='rgb(1,1,1)'
                                    DryInterval={0}
                                    DryRate={0}
                                    FixedSize={FingerTip.standardFingerRadius}
                                    PaintRadius={FingerTip.maxFingerRadius}
                                    OnClear={(crc: CanvasRenderingContext2D)=>{

                                        let f= crc.font;
                                        crc.fillStyle='black';
                                        var words = this.state.splashText.split(" ");
                                        var currentLine = words[0];
                                        let y = 190;
                                        for (var i = 1; i < words.length; i++) {
                                            var word = words[i];
                                            var met = crc.measureText(currentLine + " " + word);
                                            var width = met.width;
                                            if (width < 280) {
                                                currentLine += " " + word;
                                            } else {
                                                crc.fillText(currentLine, 60, y);
                                                y+= met.actualBoundingBoxAscent + met.actualBoundingBoxDescent;
                                                currentLine = word;
                                            }
                                        }
                                        crc.fillText(currentLine, 60, y);

                                    }}
                                    TextureSmash={false}
                                    SampleMode={false}
                                    OnColorSample={(rgb)=>{}}
                                    ExceptionHandler={(source: string, kind: string, code: string, exception: unknown)=>{this.props.AppObject.reportException(source, kind, code, exception)}}
                                />
                                <SmesshySubButton AppObject={this._app!} Display={<span>?</span>} Haptic={this.doButtonHaptic()} StartPushedState={false} ExtraStyleClass='smesshy-wtf' OnPressFinish={async (): Promise<boolean>=>{
                                    controlThis.setState({askQuestion:{
                                        Top: 100,
                                        Title: <span>What Did That Say?</span>,
                                        Prompts: [<span key={'l1'}>{this.state.splashText}</span>],
                                        Options: [{Key:'okGreat', Option:<span>Uhh... thanks ?!?</span>, OnOption:async ():Promise<boolean>=>{
                                            controlThis.setState({askQuestion:undefined})
                                            return true;
                                        }}], OnCancel:()=>{
                                            controlThis.setState({askQuestion:undefined});
                                        }
                                    }});
                                    return true;
                                }}/>
                            </div>
                        </div>
        
                        <div className='game-page-mid width-100p smesshy-main text-white' >
                            <div className='width-100p height-100p v-items h-padding-medium v-padding-medium each-space-around' >
                                {smesshyOptions}
                            </div>
                        </div>
                    </>}
            />, this.state);
    }
}

export default Smesshy;